import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks/storeHooks";
import { fetchInspectionsList } from "../store/thunks/answerThunks";
import { selectAnswer } from "../store/selectors/answerSelectors";
import { ProgressSpinner } from "primereact/progressspinner";
import { Card } from "primereact/card";
import { InspectionListTable } from "../components/Answer/InspectionListTable";

const InspectionList = () => {
    const dispatch = useAppDispatch();
    const { loadingInspections, errorInspections } = useAppSelector(selectAnswer);

    useEffect(() => {
        dispatch(fetchInspectionsList());
    }, [dispatch]);

    if (loadingInspections) {
        return (
            <div className="flex h-full align-items-center justify-content-center">
                <ProgressSpinner />
            </div>
        );
    }

    if (errorInspections) {
        return (
            <div className="flex align-items-center justify-content-center">
                <p>Failed to load inspections :(</p>
            </div>
        );
    }

    return (
        <div className="flex flex-column gap-3">
            <Card>
                <InspectionListTable />
            </Card>
        </div>
    );
};

export default InspectionList;
